<template>
  <div class="mainDiv">
    <!-- <el-tabs v-model="reviewStatus" type="card">
      <el-tab-pane
        v-for="item in reviewStatusList"
        :key="item.value"
        :label="item.label"
        :name="item.name"
      ></el-tab-pane>
    </el-tabs>    -->
    <div class="title">
      华南理工大学自学考试{{total}}门过程性评价课程资源情况统计
      <div style="font-size:24px">(20220518统计)</div>
    </div>

    <div class="image">
        <!-- <img class="num" :src="num" alt="" /> -->
        <!-- <img class="num" :src="num2" alt="" />
        <img class="num" :src="num3" alt="" /> -->
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      size="small"
      :header-cell-style="{ 'background-color': '#e8eff9',color:'#333','font-size':'14px' }"
    >
      
      <el-table-column width="50" prop="id" label="序号" align="center"></el-table-column>
      <el-table-column
        prop="courseCode"
        label="课程代码"
        align="center"
        header-align="center"
        width="80"
      >
      </el-table-column>
      <el-table-column
        prop="courseName"
        label="课程名称"
        align="center"
        header-align="center"
      >
        <template slot-scope="scope">
          <div style="color: #409eff; cursor: pointer">
            {{ scope.row.courseName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="audioVideoCount"
        label="音视频资源（个）"
        align="center"
        header-align="center"
        width="140"
      >
      </el-table-column>
      <el-table-column
        prop="questionCount"
        label="题库资源（题）"
        align="center"
        header-align="center"
        width="140"
      ></el-table-column>
       <el-table-column
        prop="sectionChapterCount"
        label="教学章数（章）"
        align="center"
        header-align="center"
        width="180"
      ></el-table-column>
      <el-table-column
        prop="sectionCount"
        :label="'教学节数（节）'"
        align="center"
        header-align="center"
        width="180"
      ></el-table-column>
      <el-table-column
        prop="knowledgeCount"
        label="考试大纲知识点（个）"
        align="center"
        header-align="center"
        width="140"
      >
      </el-table-column>
      <el-table-column
        prop="kgStatus"
        label="教纲覆盖考纲状态"
        align="center"
        header-align="center"
        width="140"
      ></el-table-column>
      <el-table-column
        prop="averageNumber" 
        label="每知识点平均题数"
        align="center"
        header-align="center"
        width="140"
      ></el-table-column>
      <el-table-column
        prop="jobTimes"
        label="阶段作业（套）"
        align="center"
        header-align="center"
        width="140"
      ></el-table-column>
      <el-table-column
        prop="testTimes"
        label="综合测试（套）"
        align="center"
        header-align="center"
        width="140"
      ></el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
// 综合测验接口
import * as api from '@/api/TeachingStatistics'
import num from '@/static/images/num5.jpg'
import num2 from '@/static/images/num2.png'
import num3 from '@/static/images/num3.png'
export default {
  components: {}, 
  data() {
    return {

      num:num,
      num2:num2,
      num3:num3,
      reviewStatusList: [{ value: '0', label: '资源统计', name: '0' }],
      reviewStatus: '0',

      tableData: [],
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      total: 0,
      totalDate:''
    }
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
  created() {
    this.resourcesStatisticsList()
   
  },
 
  methods: {
    // 获取资源统计数据
    async resourcesStatisticsList() {
      const { data, code } = (
        await api.resourcesStatisticsList({
          uid: this.getUId,
          ...this.pageObj,
        })
      ).data
      
      if (code === 100000) {
        if(data.list.length> 0){
          console.log("请求数据===》",data);
         
          this.tableData = data.list
         
          this.total = data.total
        }else{
           this.tableData = []
        }
        
      }
    },

    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.resourcesStatisticsList()
    },
    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.resourcesStatisticsList()
    },

  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/classManagement.scss';
/deep/.el-collapse {
  padding-bottom: 20px;
}
.title{
    width: 100%;
    text-align: center;
    font-size:28px;
}
.image{
    display: flex;
    flex-direction: column;
    justify-content: center;
    // width: 1200px;
    // margin: 0 auto;
}
.table_control {
  color: #409eff;
  .table_control_item {
    vertical-align: middle;
    cursor: pointer;
  }
}
/deep/ .el-table th > .cell {
  white-space: pre-wrap;
}
.t_export{
  margin: 0 auto;
  text-align: center;
}
.t_exportTitle{
  margin-bottom: 20px;
}
.t_count{
  color:red;
  font-weight: 600;
}
/deep/ .el-dialog__body{padding-top:18px}
/deep/ .el-dialog__header{background:#eeeeee}
</style>
